import { render, staticRenderFns } from "./BanksFilterPsuTypes.vue?vue&type=template&id=0ed40af8&"
import script from "./BanksFilterPsuTypes.vue?vue&type=script&lang=js&"
export * from "./BanksFilterPsuTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports